export default __webpack_public_path__ + "static/media/og_image.c6e8cab1.png";